import { Field, FormikProps, useFormikContext } from 'formik'
import React from 'react'
import RadioInput from '../../../../../../../components/inputs/RadioInput'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { B9_FORM_INITIAL_VALUES } from './constants'

interface Props {}

export const B9CivilProtectionForm: React.FC<Props> = (props) => {
  const formik = useFormikContext() as FormikProps<typeof B9_FORM_INITIAL_VALUES>
  return (
    <>
      <FormSectionTwoColumns
        sectionKey="b9.citizenAlertSystem"
        title="a) způsob zajištění varování a informování obyvatelstva před hrozící nebo nastalou mimořádnou událostí"
      >
        <div className="sm:col-span-6">
          <Field
            name="b9.citizenAlertSystem.enabled"
            component={RadioInput}
            label="Je součástí projektu?"
            options={[
              {
                label: 'Ano',
                value: true,
              },
              {
                label: 'Ne',
                value: false,
              },
            ]}
          />
          {formik.values.b9.citizenAlertSystem.enabled && (
            <Field
              name="b9.citizenAlertSystem.description"
              component={RichTextInput}
              aiHint="Ochrana obyvatelstva - způsob zajištění varování a informování obyvatelstva před hrozící nebo nastalou mimořádnou událostí"
            />
          )}
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b9.populationShelter"
        title="b) způsob zajištění ukrytí obyvatelstva"
      >
        <div className="sm:col-span-6">
          <Field
            name="b9.populationShelter.enabled"
            component={RadioInput}
            label="Je součástí projektu?"
            options={[
              {
                label: 'Ano',
                value: true,
              },
              {
                label: 'Ne',
                value: false,
              },
            ]}
          />
          {formik.values.b9.populationShelter.enabled && (
            <Field
              name="b9.populationShelter.description"
              component={RichTextInput}
              aiHint="Ochrana obyvatelstva - způsob zajištění ukrytí obyvatelstva"
            />
          )}
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b9.protectionAgainstSubstances"
        title="c) způsob zajištění ochrany před nebezpečnými účinky nebezpečných látek u staveb v zónách havarijního plánování"
      >
        <div className="sm:col-span-6">
          <Field
            name="b9.protectionAgainstSubstances.enabled"
            component={RadioInput}
            label="Je součástí projektu?"
            options={[
              {
                label: 'Ano',
                value: true,
              },
              {
                label: 'Ne',
                value: false,
              },
            ]}
          />
          {formik.values.b9.protectionAgainstSubstances.enabled && (
            <Field
              name="b9.protectionAgainstSubstances.description"
              component={RichTextInput}
              aiHint="Ochrana obyvatelstva - způsob zajištění ochrany před nebezpečnými účinky nebezpečných látek u staveb v zónách havarijního plánování"
            />
          )}
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b9.floodProtection"
        title="d) způsob zajištění ochrany před povodněmi"
      >
        <div className="sm:col-span-6">
          <Field
            name="b9.floodProtection.enabled"
            component={RadioInput}
            label="Je součástí projektu?"
            options={[
              {
                label: 'Ano',
                value: true,
              },
              {
                label: 'Ne',
                value: false,
              },
            ]}
          />
          {formik.values.b9.floodProtection.enabled && (
            <Field
              name="b9.floodProtection.description"
              component={RichTextInput}
              aiHint="Ochrana obyvatelstva - způsob zajištění ochrany před povodněmi"
            />
          )}
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b9.buildingSelfSufficiency"
        title="e) způsob zajištění soběstačnosti stavby pro případ výpadku elektrické energie u staveb občanského vybavení"
      >
        <div className="sm:col-span-6">
          <Field
            name="b9.buildingSelfSufficiency.enabled"
            component={RadioInput}
            label="Je součástí projektu?"
            options={[
              {
                label: 'Ano',
                value: true,
              },
              {
                label: 'Ne',
                value: false,
              },
            ]}
          />
          {formik.values.b9.buildingSelfSufficiency.enabled && (
            <Field
              name="b9.buildingSelfSufficiency.description"
              component={RichTextInput}
              aiHint="Ochrana obyvatelstva - způsob zajištění soběstačnosti stavby pro případ výpadku elektrické energie u staveb občanského vybavení"
            />
          )}
        </div>
      </FormSectionTwoColumns>
      <FormSectionTwoColumns
        sectionKey="b9.civilProtection"
        title="f) způsob zajištění ochrany stávajících staveb civilní ochrany v území dotčeném stavbou nebo staveništěm, jejich výčet, umístění a popis možného dotčení jejich funkce a provozuschopnosti"
      >
        <div className="sm:col-span-6">
          <Field
            name="b9.civilProtection.enabled"
            component={RadioInput}
            label="Je součástí projektu?"
            options={[
              {
                label: 'Ano',
                value: true,
              },
              {
                label: 'Ne',
                value: false,
              },
            ]}
          />
          {formik.values.b9.civilProtection.enabled && (
            <Field
              name="b9.civilProtection.description"
              component={RichTextInput}
              aiHint="Ochrana obyvatelstva - způsob zajištění ochrany stávajících staveb civilní ochrany v území dotčeném stavbou nebo staveništěm, jejich výčet, umístění a popis možného dotčení jejich funkce a provozuschopnosti"
            />
          )}
        </div>
      </FormSectionTwoColumns>
    </>
  )
}
